import { RouterLink as Link } from "../../router";
import { ChevronRight, HelpCircle } from "../../icons";

export interface HelpBreadcrumbProps {
  categoryName?: string;
  categorySlug?: string;
  articleTitle?: string;
}

/**
 * "Help / <Category> / <Article>" breadcrumb. Each step links to the
 * appropriate route; the last step (the active page) is muted.
 */
export function HelpBreadcrumb({
  categoryName,
  categorySlug,
  articleTitle,
}: HelpBreadcrumbProps) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="flex items-center gap-1 type-body text-muted-foreground"
    >
      <Link
        href="/help"
        className="inline-flex items-center gap-1 hover:text-foreground"
      >
        <HelpCircle aria-hidden className="size-3.5" />
        Help
      </Link>
      {categorySlug && categoryName ? (
        <>
          <ChevronRight aria-hidden className="size-3.5" />
          {articleTitle ? (
            <Link
              href={`/help/${categorySlug}`}
              className="hover:text-foreground"
            >
              {categoryName}
            </Link>
          ) : (
            <span className="text-foreground">{categoryName}</span>
          )}
        </>
      ) : null}
      {articleTitle ? (
        <>
          <ChevronRight aria-hidden className="size-3.5" />
          <span className="text-foreground">{articleTitle}</span>
        </>
      ) : null}
    </nav>
  );
}
